import Api from '@/helpers/api';
/**
 * Obtiene la lista de usuarios
 *
 * @returns {Promise<Users>} Promise - una promesa con la lista de usuarios // Error
 */
const getAllUsers = async () => {
    const result = await Api.get('/users');
    return result.data;
};

/**
 * Obtiene un usuario, por su ID.
 *
 * @param {string} id - el Id del usuario
 * @returns {Promise<Users>} Promise una promesa con el estado del servicio // Error
 */
const getOneUser = async (id) => {
    const result = await Api.get(`/users/${id}`);
    return result.data;
};

/**
 * Guarda un usuario
 *
 * @param {object} user - un objeto con los datos del usuario a guardar
 * @returns {Promise<Users>} Promise - una promesa con el estado del servicio // Error
 */
const saveUser = async (user) => {
    const result = await Api.post('/users', user);
    return result.data;
};

/**
 * Actualiza un usuario
 *
 * @param {string} id - el Id del usuario
 * @param {object} user - un objeto con los datos del usuario a actualizar
 * @returns {Promise<Users>} Promise - una promesa con el estado del servicio // Error
 */
const updateUser = async (id, user) => {
    const result = await Api.put(`/users/${id}`, user);
    return result.data;
};

/**
 * Activar un usuario
 *
 * @param {string} userID - el Id del usuario
 * @param {object} companyID - un objeto con los datos del usuario a actualizar
 * @returns {Promise<Users>} Promise - una promesa con el estado del servicio // Error
 */
 const activeUser = async (userID, companyID) => {
    const result = await Api.post(`/users/active`, {userID, companyID})
    return result.data;
};

/**
 * Elimina un usuario
 *
 * @param {string} id - el Id del usuario
 * @returns {Promise<Users>} Promise - una promesa con el estado del servicio // Error
 */
const deleteUser = async (id) => {
    const result = await Api.delete(`/users/${id}`);
    return result.data;
};

/**
 * obtiene los roles
 *
 * @returns {Promise<Roles>} Promise - una promesa con todos los roles
 */
 const getRoles = async () => {
    const result = await Api.get(`/roles`);
    return result.data;
};

/**
 * obtiene los roles
 *
 * @returns {Promise<Status>} Promise - una promesa con todos los roles
 */
 const getStatus = async () => {
    const result = await Api.get(`/status`);
    return result.data;
};

export { getAllUsers, getOneUser, saveUser, updateUser, activeUser, deleteUser, getRoles, getStatus };
